import { Failure } from "@megaron/result";

import { JsonStringSerializer, serializerExtensions } from "../extensions";
import { Serializer } from "../serializer";
import { getSerializerSchema } from "../serializerSchema";

export const jsonString = <T>(contentSerializer: Serializer<T>): JsonStringSerializer<T> => ({
  schema: { kind: "jsonString", inner: getSerializerSchema(contentSerializer) },
  serialize: (value) => JSON.stringify(contentSerializer.serialize(value)),
  deserialize: (raw) => {
    if (typeof raw !== "string") return Failure("NotAString");
    try {
      const parsed = JSON.parse(raw);
      return contentSerializer.deserialize(parsed);
    } catch (e) {
      return Failure("InvalidJson");
    }
  },
  ...serializerExtensions(),
});
